import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Checkbox from '@jimmyboys/liita-ui/dist/components/Checkbox'

import styles from './Dialog.module.sass'
import { status } from 'models/Appointment'

export const flatHookFormErrors = (obj, current, res = {}) => {
	for (let key in obj) {
		if (!['ref', 'code'].includes(key)) {
			const value = obj[key]
			const newKey = current ? current + '.' + key : key
			if (value && typeof value === 'object') {
				flatHookFormErrors(value, newKey, res)
			} else {
				if (key === 'message') {
					res[newKey] = value
				}
			}
		}
	}
	return res
}

export const renderMedicalActs = (medicalActs, isSurgery = false) => {
	return medicalActs.map((elem, idx) => {
		return (
			<HStack
				key={idx}
				className={styles['quantities-group']}
				gap='xsmall'
				align='center'
				flex={[
					[1, 1],
					[0, 0],
					[0, 0],
				]}
			>
				<span>
					<Checkbox
						tint={'accent'}
						disabled={true}
						className={styles['checkbox']}
						label={`${elem?.code ? `${elem?.code}: ` : ''}${
							elem?.description || elem?.name
						}`}
						checked={true}
					/>
				</span>
				<span>
					<input
						className={`${styles['input']} ${
							styles[`tint-accent`]
						}`}
						type='text'
						value={
							isSurgery
								? elem?.percentage ?? 100
								: elem?.requestedQuantity ?? 1
						}
						disabled={true}
					/>
					{!isSurgery && (
						<small>{` / ${elem?.requestedQuantity ?? 0}`}</small>
					)}
					{isSurgery && (
						<small className='nowrap'>
							{` % ${elem?.kValue ? `K: ${elem?.kValue}` : ''}`}
						</small>
					)}
				</span>
			</HStack>
		)
	})
}

export const renderExams = (exams) => {
	return exams.map((elem, idx) => {
		return (
			<span key={idx} className={styles['quantities-group']}>
				<Checkbox
					tint={'accent'}
					disabled={true}
					className={styles['checkbox']}
					label={`${elem?.code ? `${elem?.code}: ` : ''}${
						elem?.description || elem?.name
					}`}
					checked={true}
				/>
			</span>
		)
	})
}

export const getNextAppointment = (appointments) => {
	const orderedAppointments = appointments
		?.map((elem) => ({
			...elem,
			sortParam: elem.date?.timestamp,
		}))
		?.sort((a, b) => b.sortParam - a.sortParam)

	return orderedAppointments?.find(
		(elem) => elem.status?.value === status.ON_GOING
	)
}
